export const toPrice = (price, scale) =>
    String(((price * 100) / 100).toFixed(scale || 2))
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
